/** 维护常用按键 */
export enum Keys {
  /** Control 键 */
  Control = 'Control',

  /** 苹果 Command 键 */
  Command = 'Meta',

  /** 删除键 */
  Delete = 'Delete',

  /** 后退 */
  Backspace = 'Backspace',

  ArrowUp = 'ArrowUp',

  ArrowDown = 'ArrowDown',

  ArrowLeft = 'ArrowLeft',

  ArrowRight = 'ArrowRight'
}
